export default "__VITE_ASSET__CqDz3RYP__"